module.exports = require('./lib/axios');


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/user-permissions/~/axios/index.js
 ** module id = 280
 ** module chunks = 0
 **/